module.exports = __webpack_public_path__ + "static/assets/4a0805c514a257e9638ad661d9c34f30.svg";